import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card';
import { Logo } from '../../components/logos/logo';

export function Welcome() {
  const navigate = useNavigate();

  const handleContinue = () => {
    void navigate('../setup/verify-domain');
  };

  return (
    <div className="flex items-center justify-center w-screen">
      <Card className="w-full max-w-xl mx-4 sm:mx-auto p-9 rounded-[1rem]">
        <CardHeader className="items-center space-y-8 p-0">
          <Logo icon="contextual" width={36} height={36} />
          <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium">
            Welcome to Contextual
          </h1>
        </CardHeader>
        <CardContent className="my-9 p-0">
          <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold mb-4">
            To get setup with Contextual, you will need to access:
          </h2>

          <p className="font-bold text-xs sm:text-sm md:text-base lg:text-lg">Your DNS Provider</p>
          <span className="text-xs sm:text-xs md:text-sm lg:text-base">{`It's where you add DNS records for the site you want to add. This step is required to verify you are the first party to the Internet for your setup.`}</span>

          <p className="font-bold mt-4 font-bold text-xs sm:text-sm md:text-base lg:text-lg">
            Your Shopify store admin panel
          </p>
          <span className="text-xs sm:text-xs md:text-sm lg:text-base">{`You will need to install the Contextual app in Shopify, add custom pixel code and enable app embeds.`}</span>
        </CardContent>
        <CardFooter className="p-0 justify-center">
          <Button onClick={handleContinue}>{`Continue`}</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
